export const actionTypes = {
  REMOVE_TOAST: "REMOVE_TOAST",
  UPDATE_SALE_DATA: "UPDATE_SALE_DATA",

  GET_SALE: "GET_SALE",
  GET_SALE_SUCCESS: "GET_SALE_SUCCESS",
  GET_SALE_FAILED: "GET_SALE_FAILED",
  UPDATE_SALE: "UPDATE_SALE",
  UPDATE_SALE_SUCCESS: "UPDATE_SALE_SUCCESS",
  UPDATE_SALE_FAILED: "UPDATE_SALE_FAILED",
  DELETE_SALE: "DELETE_SALE",
  DELETE_SALE_SUCCESS: "DELETE_SALE_SUCCESS",
  DELETE_SALE_FAILED: "DELETE_SALE_FAILED",
  ADD_SALE: "ADD_SALE",
  ADD_SALE_SUCCESS: "ADD_SALE_SUCCESS",
  ADD_SALE_FAILED: "ADD_SALE_FAILED"
}

const initialState = {
  data: null,
  meta: null,
  isLoading: false,
  toast: null,
  errors: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REMOVE_TOAST:
      return Object.assign({}, state, {
        toast: null
      })
    case actionTypes.UPDATE_OVERHEAD_DATA:
      return Object.assign({}, state, {
        data: action.state
      })
    case actionTypes.GET_SALE:
    case actionTypes.UPDATE_SALE:
    case actionTypes.DELETE_SALE:
    case actionTypes.ADD_SALE:
      return Object.assign({}, state, { isLoading: true, errors: null });
    case actionTypes.GET_SALE_FAILED:
    case actionTypes.UPDATE_SALE_FAILED:
    case actionTypes.ADD_SALE_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        errors: action.errors
      });
    case actionTypes.GET_SALE_SUCCESS:
      return Object.assign({}, state, {
        data: action.payload.data,
        meta: action.payload.meta,
        isLoading: false,
        errors: null,
      });
    case actionTypes.UPDATE_SALE_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: {
          type: "success",
          message: "Successfully Updated expense"
        }
      });
    case actionTypes.DELETE_SALE_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: {
          type: "success",
          message: "Successfully deleted expense"
        }
      });
    case actionTypes.ADD_SALE_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: {
          type: "success",
          message: "Successfully added expense",
          request: "add"
        }
      });
    default:
      return state;
  }
}

export const actionCreators = {
  removeToast: () => ({
    type: actionTypes.REMOVE_TOAST
  }),
  updateSaleData: state => ({
    type: actionTypes.UPDATE_SALE_DATA, state
  }),
  getSale: (company_id, params) => ({
    type: actionTypes.GET_SALE,
    company_id, params
  }),
  addSale: (company_id, body) => ({
    type: actionTypes.ADD_SALE,
    company_id, body
  }),
  updateSale: (company_id, sale_id, body) => ({
    type: actionTypes.UPDATE_SALE,
    company_id,
    sale_id,
    body
  }),
  deleteSale: (company_id, sale_id) => ({
    type: actionTypes.DELETE_SALE,
    company_id,
    sale_id
  })
}


// WEBPACK FOOTER //
// ./src/modules/company/pages/sales-forecast/reducer.js